import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUfStageOneForm,
  fetchUfStageTwoForm,
  fetchUfStageOneData,
  fetchUfStageTwoData,
  fetchViewUfStageOneData,
  fetchViewUfStageTwoData,
  UpdateUfFlowStatus,
  fetchUfFlowHistory,
  fetchUfFrameNo,
  fetchUfMasterNumbers,
  checkDuplicateFrametype
} from './underFrameThunk';

const initialState = {
  ufStageOne: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  ufStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  ufStageOneData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },
  ufStageTwoData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },
  viewStageOneData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewStageTwoData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  flowHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  updateFlowStatus: {
    loading: false,
    success: false,
    error: null,
  },
  getUfFrameNumber: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getMasterUfNo: {
    loading: false,
    error: null,
    uf_nos: [],
  },
  checkDuplicateFrametype: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
};

const ufStageOneSlice = createSlice({
  name: 'underFrame',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUfStageOneForm.pending, (state) => {
        state.ufStageOne.loading = true;
        state.ufStageOne.error = null;
      })
      .addCase(fetchUfStageOneForm.fulfilled, (state, action) => {
        state.ufStageOne.loading = false;
        state.ufStageOne.data = action.payload;
      })
      .addCase(fetchUfStageOneForm.rejected, (state, action) => {
        state.ufStageOne.loading = false;
        state.ufStageOne.error = action.payload || 'Failed to fetch stage one params';
      })
      .addCase(fetchUfStageTwoForm.pending, (state) => {
        state.ufStageTwo.loading = true;
        state.ufStageTwo.error = null;
      })
      .addCase(fetchUfStageTwoForm.fulfilled, (state, action) => {
        state.ufStageTwo.loading = false;
        state.ufStageTwo.data = action.payload;
      })
      .addCase(fetchUfStageTwoForm.rejected, (state, action) => {
        state.ufStageTwo.loading = false;
        state.ufStageTwo.error = action.payload || 'Failed to fetch stage two params';
      })
      .addCase(fetchUfStageOneData.pending, (state) => {
        state.ufStageOneData.loading = true;
        state.ufStageOneData.error = null;
      })
      .addCase(fetchUfStageOneData.fulfilled, (state, action) => {
        state.ufStageOneData.loading = false;
        state.ufStageOneData.data = action.payload.data;
        state.ufStageOneData.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.total_pages || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchUfStageOneData.rejected, (state, action) => {
        state.ufStageOneData.loading = false;
        state.ufStageOneData.error = action.payload || 'Failed to fetch stage one submitted data';
      })
      .addCase(fetchUfStageTwoData.pending, (state) => {
        state.ufStageTwoData.loading = true;
        state.ufStageTwoData.error = null;
      })
      .addCase(fetchUfStageTwoData.fulfilled, (state, action) => {
        state.ufStageTwoData.loading = false;
        state.ufStageTwoData.data = action.payload.data;
        state.ufStageTwoData.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.total_pages || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchUfStageTwoData.rejected, (state, action) => {
        state.ufStageTwoData.loading = false;
        state.ufStageTwoData.error = action.payload || 'Failed to fetch stage one submitted data';
      })

      .addCase(fetchViewUfStageOneData.pending, (state) => {
        state.viewStageOneData.loading = true;
        state.viewStageOneData.error = null;
      })
      .addCase(fetchViewUfStageOneData.fulfilled, (state, action) => {
        state.viewStageOneData.loading = false;
        state.viewStageOneData.data = action.payload.data;
      })
      .addCase(fetchViewUfStageOneData.rejected, (state, action) => {
        state.viewStageOneData.loading = false;
        state.viewStageOneData.error = action.payload || 'Failed to fetch stage one submitted data';
      })

      .addCase(fetchViewUfStageTwoData.pending, (state) => {
        state.viewStageTwoData.loading = true;
        state.viewStageTwoData.error = null;
      })
      .addCase(fetchViewUfStageTwoData.fulfilled, (state, action) => {
        state.viewStageTwoData.loading = false;
        state.viewStageTwoData.data = action.payload.data;
      })
      .addCase(fetchViewUfStageTwoData.rejected, (state, action) => {
        state.viewStageTwoData.loading = false;
        state.viewStageTwoData.error = action.payload || 'Failed to fetch stage two submitted data';
      })
      .addCase(fetchUfFlowHistory.pending, (state) => {
        state.flowHistory.loading = true;
        state.flowHistory.error = null;
      })
      .addCase(fetchUfFlowHistory.fulfilled, (state, action) => {
        state.flowHistory.loading = false;
        state.flowHistory.data = action.payload.data;
      })
      .addCase(fetchUfFlowHistory.rejected, (state, action) => {
        state.flowHistory.loading = false;
        state.flowHistory.error = action.payload || 'Failed to fetch history';
      })
      .addCase(UpdateUfFlowStatus.pending, (state) => {
        state.updateFlowStatus.loading = true;
        state.updateFlowStatus.error = null;
      })
      .addCase(UpdateUfFlowStatus.fulfilled, (state) => {
        state.updateFlowStatus.loading = false;
        state.updateFlowStatus.success = true;
      })
      .addCase(UpdateUfFlowStatus.rejected, (state, action) => {
        state.updateFlowStatus.loading = false;
        state.updateFlowStatus.error = action.payload || 'Failed to update status';
      })

      .addCase(fetchUfFrameNo.pending, (state) => {
        state.getUfFrameNumber.loading = true;
        state.getUfFrameNumber.error = null;
      })
      .addCase(fetchUfFrameNo.fulfilled, (state, action) => {
        state.getUfFrameNumber.loading = false;
        state.getUfFrameNumber.data = action.payload.data;
      })
      .addCase(fetchUfFrameNo.rejected, (state, action) => {
        state.getUfFrameNumber.loading = false;
        state.getUfFrameNumber.error = action.payload || 'Failed to fetch uf frame number';
      })
      .addCase(fetchUfMasterNumbers.pending, (state) => {
        state.getMasterUfNo.loading = true;
        state.getMasterUfNo.error = null;
      })
      .addCase(fetchUfMasterNumbers.fulfilled, (state, action) => {
        state.getMasterUfNo.loading = false;
        state.getMasterUfNo.uf_nos = action.payload.data;
      })
      .addCase(fetchUfMasterNumbers.rejected, (state, action) => {
        state.getMasterUfNo.loading = false;
        state.getMasterUfNo.error = action.payload || 'Failed to fetch master uf types';
      })
       .addCase(checkDuplicateFrametype.pending, (state) => {
        state.checkDuplicateFrametype.loading = true;
        state.checkDuplicateFrametype.error = null;
      })
      .addCase(checkDuplicateFrametype.fulfilled, (state, action) => {
        state.checkDuplicateFrametype.loading = false;
        state.checkDuplicateFrametype.success = true;
        state.checkDuplicateFrametype.data = action.payload.data;
      })
      .addCase(checkDuplicateFrametype.rejected, (state, action) => {
        state.checkDuplicateFrametype.loading = false;
        state.checkDuplicateFrametype.error = action.payload || 'Failed to check duplicate frametype';
      });
  },
});

export default ufStageOneSlice.reducer;
